import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.48 18.21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m20.95 7.68-.31-.52c-.53-.88-1.57-1.45-2.66-1.45h-2.35V3.13c0-.79-.25-1.48-.73-1.99a3.04 3.04 0 0 0-2.38-1.15c-.94 0-1.82.44-2.43 1.21L7.18 5.08a2.49 2.49 0 0 0-2.23-1.39H2.51a2.5 2.5 0 0 0-2.5 2.5v9.5a2.5 2.5 0 0 0 2.5 2.5h2.44c1.02 0 1.9-.62 2.29-1.5l.04.05c.53.71 1.42 1.13 2.37 1.13h7.09c1.46 0 2.67-.93 3-2.28l1.56-5.25c.33-.88.19-1.92-.35-2.68ZM5.44 15.71c0 .28-.22.5-.5.5H2.5c-.28 0-.5-.22-.5-.5v-9.5c0-.28.22-.5.5-.5h2.44c.28 0 .5.22.5.5zm13.73-6.13s-.02.06-.03.1l-1.59 5.34c-.11.44-.49.6-.81.6H9.65c-.24 0-.45-.09-.6-.27l-1.24-1.46c-.1-.12-.23-.22-.37-.28V8.32c.15-.08.3-.18.41-.33l4.04-5.39c.32-.41.92-.41 1.25 0 .03.04.06.07.09.1.1.1.12.29.12.44v3.71c0 .63.51 1.14 1.14 1.14h3.49c.29 0 .59.15.71.35l.34.56s.04.07.07.1c.1.13.16.39.08.58Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }